import SmileIcon from "../../assets/icons/smile-icon";
import comingsoonImage from "../../assets/images/construction.jpg";
import StoreCreation from "../../components/settings/system-settings/store-creation";
import PermissionSettings from "../../components/settings/permission-settings";
import DocumentNumberingIcon from "../../assets/icons/documentNum-icon";
import PrintPreferenceIcon from "../../assets/icons/print-preference-icon";
import CompanyLevelIcon from "../../assets/icons/company-level-icon";
import StoreLicensingIcon from "../../assets/icons/store-licencing";
import UserInfoIcon from "../../assets/icons/user-info";
import AuthorizationIcon from "../../assets/icons/authorisation";
import LicensingIcon from "../../assets/icons/licensing";
import TaxSetupIcon from "../../assets/icons/tax-setup";
import ItemSetupIcon from "../../assets/icons/item-setup";
import ManufacturerSetupIcon from "../../assets/icons/manufacturer-setup";
import UomGroupIcon from "../../assets/icons/uom-group";
import UomIcon from "../../assets/icons/uom";
import ShippingSetupIcon from "../../assets/icons/shipping-setup-icon";
import StoreDetailsIcon from "../../assets/icons/store-details-icon";
import PriceListDisIcon from "../../assets/icons/price-list-discount-icon.js";
import ChartOfAccIcon from "../../assets/icons/chart-of-acc-icon.js";
import PeriodVolumeIcon from "../../assets/icons/period-volume-icon.js";
import AccountAllocationIcon from "../../assets/icons/account-allocation-icon.js";
import JournalEntryIcon from "../../assets/icons/Journal-Entry-icon.js";
import AltItemIcon from "../../assets/icons/alt-item-icon.js";
import CompositionIcon from "../../assets/icons/composition-icon.js";
import PaymentTerms from "../../assets/icons/PaymentTerms.js";
import PartyCategory from "../../assets/icons/partty-category.js";
import SpecializationIcon from "../../assets/icons/specialization.js";
import { Bell, CalendarCheck, Megaphone, MapPin, Archive, UserRoundCog, SlidersHorizontal, ReceiptText, Server } from "lucide-react";
import { FaUserLock } from "react-icons/fa";
import InsuranceProvider from "../../assets/icons/insurance-provider.js";
import UserInfoCog from "../../assets/icons/user-info-cog.js";
import RoleAndDepartment from "../../assets/icons/roles-department.js";
import Authorizations from "../../assets/icons/authorizations.js";
import DocumentNumbering from "../../assets/icons/document-numbering.js";
const NoChild = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <img alt="Coming soon" src={comingsoonImage} />
    </div>
  );
};

const settingsData = [
  {
    icon: <SmileIcon />,
    title: "System Settings",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <CompanyLevelIcon />,
        title: "Company Level Settings",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/general-settings/company-level-settings ",
        input: <NoChild />,
        module_name: "company_level_setting",
      },
      {
        icon: <StoreDetailsIcon />,
        title: "Store Details",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/general-settings/store-creation",
        input: <StoreCreation />,
        module_name: "store_details",
      },
      {
        icon: <StoreLicensingIcon />,
        title: "Store Licensing",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/general-settings/store-licensing ",
        input: <NoChild />,
        module_name: "store_licensing",
      },
      {
        icon: <DocumentNumberingIcon />,
        title: "Document Numbering Series",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/document-numbering-series",
        input: null,
        module_name: "document_numbering",
      },
      {
        icon: <DocumentNumbering fill="#fff" />,
        title: "Custom Document Numbering Series",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/custom-numbering-series",
        input: null,
        module_name: "document_numbering",
      },
      {
        icon: <PrintPreferenceIcon />,
        title: "Print Preferences",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/print-preference",
        input: null,
        module_name: "print_perfernces",
      },
      {
        icon: <SmileIcon />,
        title: "Module Settings",
        desc: "Configure modules and their options",
        path: "/settings/module-settings",
        input: null,
        module_name: "store_details",
      },
      {
        icon: <AuthorizationIcon />,
        title: "Vendor Mapping",
        desc: "Map your vendor",
        path: "/settings/bussiness-catalouge",
        input: null,
        module_name: "customization",
      },
      {
        icon: <AuthorizationIcon />,
        title: "Invoice Customization",
        desc: "Customize Your Invoice",
        path: "/settings/invoice-customization",
        input: null,
        module_name: "customization",
      },
      {
        icon: <SmileIcon />,
        title: "Sync Rule",
        desc: "Sync Rule Configuration",
        path: "/settings/sync-rule",
        input: null,
        module_name: "store_details",
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "User Settings",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <UserInfoCog fill="#fff" />,
        title: "User Info",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        input: null,
        path: "/user",
        module_name: "user_info",
      },
      {
        icon: <RoleAndDepartment fill="#fff" />,
        title: "Role and Department",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        input: null,
        path: "/settings/department-and-role-setup",
        module_name: "user_info",
      },

      {
        icon: <Authorizations fill="#fff" />,
        title: "Authorizations",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/general-settings",
        input: <PermissionSettings />,
        module_name: "authorizations",
      },
      {
        icon: < SlidersHorizontal stroke="#fff" />,
        title: "Customization",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/customization",
        input: null,
        module_name: "customization",
      },
      {
        icon: <LicensingIcon />,
        title: "Licensing",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/store-details",
        input: <NoChild />,
        module_name: "licensing",
      },

      {
        icon: <SmileIcon />,
        title: "Display Settings",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings",
        input: <NoChild />,
        module_name: "display_setting",
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Data Setup",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <ReceiptText fill="#ffff" stroke="#277dfe" />,
        title: "Tax Setup",
        desc: "Tax setup,Tax combination, Accounting",
        path: "/settings/tax-setup",
        input: null,
        module_name: "tax_setup",
      },
      {
        icon: <ReceiptText fill="#ffff" stroke="#277dfe" />,
        title: "TCS - TDS Setup",
        desc: "TCS setup,TDS combination",
        path: "/settings/tcs-tds-setup",
        input: null,
        module_name: "tax_setup",
      },

      {
        icon: <ItemSetupIcon />,
        title: "Item Setup",
        desc: "Item Setup,display, warehouse, Accounting",
        path: "/settings/item-setup",
        input: null,
        childrens: [],
        module_name: "item_setup",
      },

      {
        icon: <ManufacturerSetupIcon />,
        title: "Manufacturer Setup",
        desc: "Manufacturer Setup,display, warehouse, Accounting",
        path: "/settings/manufacturer-setup",
        input: null,
        childrens: [],
        module_name: "manufacturer_setup",
      },
      {
        icon: <ShippingSetupIcon />,
        title: "Shipping Setup",
        desc: "Shipping Setup,display, warehouse, Accounting",
        path: "/settings/shipping-setup",
        input: null,
        childrens: [],
        module_name: "shipping_setup",
      },
      {
        icon: <UomIcon />,
        title: "Unit Of Measures",
        desc: "Unit of measure, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/uom-setup",
        input: null,
        childrens: [],
        module_name: "uom_setup",
      },
      {
        icon: <UomGroupIcon />,
        title: "Unit Of Measure Groups",
        desc: "Unit of measure Groups, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/uom-group-setup",
        input: null,
        childrens: [],
        module_name: "uom_group_setup",
      },
      {
        icon: <AltItemIcon />,
        title: "Alternative Items",
        desc: "Alternative items mapping",
        path: "/settings/alternative-item-setup",
        input: null,
        childrens: [],
        module_name: "uom_group_setup",
      },
      {
        icon: <AltItemIcon />,
        title: "Import Templates",
        desc: "Create Templates for importing CSVs, PDFs or Images across modules",
        path: "/settings/import-templates",
        input: null,
        childrens: [],
        module_name: "uom_group_setup",
      },
      {
        icon: <Bell stroke="white" />,
        title: "Alert Management",
        desc: "Alert Management create, customize, and maintain alerting mechanisms within a system",
        input: null,
        path: "/alerts",
        module_name: "alert_management",
      },
      {
        icon: <CalendarCheck stroke="white" />,
        title: "Schedule Drug",
        desc: "schedule Drug create, customize, and maintain",
        input: null,
        path: "/settings/schedule-drug",
        module_name: "schedule_drug",
      },
      {
        icon: <CompositionIcon fill="#fff" />,
        title: "Composition",
        desc: "Composition create, customize, and maintain",
        input: null,
        path: "/settings/composition",
        module_name: "composition_setup",
      },
      {
        icon: <Megaphone stroke="#ffffff" />,
        title: "Lead Source",
        desc: "Lead Source create, customize, and maintain",
        input: null,
        path: "/settings/lead",
        module_name: "lead_source",
      },
      {
        icon: <PaymentTerms fill="#fff" />,
        title: "Payment Terms",
        desc: "Payment Terms create, customize, and maintain",
        input: null,
        path: "/settings/payment",
        module_name: "payment_terms",
      },
      {
        icon: <ReceiptText stroke="white" />,
        title: "Payment Type",
        desc: "Payment Type create, customize, and maintain",
        input: null,
        path: "/settings/payment-type",
        module_name: "payment_terms",
      },
      {
        icon: <PartyCategory fill="#fff" />,
        title: "Party Category",
        desc: "Party Category create, customize, and maintain",
        input: null,
        path: "/settings/party",
        module_name: "party_category",
      },
      {
        icon: <SpecializationIcon fill="#fff" />,
        title: "Specialization & Sub-Specialization",
        desc: "Specialization & Sub-Specialization create, customize, and maintain",
        input: null,
        path: "/settings/specialization",
        module_name: "specialization",
      },
      {
        icon: <InsuranceProvider fill="#fff" />,
        title: "Insurance Provider",
        desc: "Insurance Provider create, customize, and maintain",
        input: null,
        path: "/settings/insurance",
        module_name: "insurance_provider",
      },
      {
        icon: <MapPin stroke="#277dfe" fill="#fff" />,
        title: "Location",
        desc: "Location create, customize, and maintain",
        input: null,
        path: "/settings/location",
        module_name: "location_setup",
      },
      {
        icon: <Server stroke="white" />,
        title: "Server",
        desc: "Server setup, display, warehouse, Accounting",
        input: null,
        path: "/settings/server",
        module_name: "location_setup",
      },
      {
        icon: <Archive stroke="#277dfe" fill="#fff" />,
        title: "Packing",
        desc: "Packing create, customize, and maintain",
        input: null,
        path: "/settings/pack-info",
        module_name: "pack_info_setup",
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Discount Settings",
    desc: "Pricelist discount, Period-Volume Discount, Discount Group",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <PriceListDisIcon />,
        title: "Price List Discounts",
        desc: "Pricelist discount",
        input: null,
        path: "/price-list",
        module_name: "price_list",
      },
      {
        icon: <PeriodVolumeIcon />,
        title: "Period-Volume Discounts",
        desc: "Period-Volume Discount",
        input: null,
        path: "/period-volume",
        module_name: "period_and_volume_discount",
      },
      {
        icon: <LicensingIcon />,
        title: "Discount groups",
        desc: "Discount Group",
        input: null,
        path: "/discount-group",
        module_name: "discount_group",
      },
      {
        icon: <Megaphone size={20} stroke="#ffffff" />,
        title: "Promotional Offers",
        desc: "Configure auto-add free item promotions based on bill amount",
        path: "/settings/promotional-offers",
        input: null,
        module_name: "promotional_offers",
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Account Settings",
    desc: "Chart of account, Account allocation, Journal Entry",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <ChartOfAccIcon />,
        title: "Chart of Accounts",
        desc: "Chart of Accounts",
        input: null,
        path: "/chart-of-account",
        module_name: "chart_of_accounts",
      },
      {
        icon: <AccountAllocationIcon />,
        title: "Account Allocation",
        desc: "Account Allocation",
        input: null,
        path: "/account-allocation",
        module_name: "account_allocation",
      },
      {
        icon: <JournalEntryIcon />,
        title: "Journal Entry",
        desc: "Journal Entry",
        input: null,
        path: "/journal-entry",
        module_name: "journal_entry",
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Data Sync Management",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <SmileIcon />,
        title: "Store wise Rules Setup",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/store-details",
        input: <NoChild />,
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Communication",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <SmileIcon />,
        title: "Whatsapp Api Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/whatsapp-configuration",
        input: null,
      },
      {
        icon: <SmileIcon />,
        title: "Message Api Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/sms-configuration",
        input: null,
      },
      {
        icon: <SmileIcon />,
        title: "SMTP Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/smtp-configuration",
        input: null,
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Payment Settings",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      // {
      //     icon: <SmileIcon />,
      //     title: "Payment Config",
      //     desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
      //     path: "settings/system-settings/store-details",
      //     input: <NoChild />,
      // },
      {
        icon: <SmileIcon />,
        title: "Razorpay Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/razorpay-configuration",
        input: null,
      },
      {
        icon: <SmileIcon />,
        title: "Stripe Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/stripe-configuration",
        input: null,
      },
      {
        icon: <SmileIcon />,
        title: "Phonepe Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/phonepe-configuration",
        input: null,
      },
      {
        icon: <SmileIcon />,
        title: "Paytm Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/paytm-configuration",
        input: null,
      },
      {
        icon: <SmileIcon />,
        title: "Pine Labs Config",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "/settings/pine-labs-configuration",
        input: null,
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Integrations",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <SmileIcon />,
        title: "Hub Spot Setup",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/store-details",
        input: <NoChild />,
      },
      {
        icon: <SmileIcon />,
        title: "ERP 1",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/store-details",
        input: <NoChild />,
      },
      {
        icon: <SmileIcon />,
        title: "ERP 2",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/store-details",
        input: <NoChild />,
      },
    ],
  },
  {
    icon: <SmileIcon />,
    title: "Human Resources",
    desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
    path: "settings/system-settings",
    childrens: [
      {
        icon: <SmileIcon />,
        title: "Hardware Setup",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/store-details",
        input: <NoChild />,
      },
      {
        icon: <SmileIcon />,
        title: "Shift Setup",
        desc: "Customer settings, inventory, alerts,display, warehouse, Accounting",
        path: "settings/system-settings/store-details",
        input: <NoChild />,
      },
    ],
  },
];

export default settingsData;
